import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import Post from "../../pages/ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
export default function CreatePost(){
    const [address1,setAddress1] = useState("-")
    const nowstate = useSelector(state => state);
    const [sales,setSales]= useState(nowstate.user?.sales??"-")
    const [date,setDate]= useState(new Date())
    const [dateEnd,setDateEnd]= useState(new Date())

    const handleChangeAddress = (event) => {
        setAddress1(event.target.value)
        const alamatDicari = event.target.value
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/confirm-address`,{
                alamatDicari
        }).then(response=>{
            console.log(response.data)
        });
    };
    const [categorias, setCategorias] = useState([]);
    const cekList = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/listCustomer`,{
            
        }).then(response=>{
            console.log(response)
        })
    }
    const getCategorias = async () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
        }).then(response=>{
          setCategorias(response.data.pilihanAlamat);
      });
        //console.log(res);
      }

      const countKontrak = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/extendRate?date=${date}&dateEnd=${dateEnd}&lokasi=${address1}&TipeKontrak=${TipeKontrak}&user=${sales}`,{
            
        }).then(resp => {
            setHitunganKontrak(resp.data.count)
        })
      }
      const [hitunganKontrak, setHitunganKontrak] = useState()
    const [extend,setExtend]= useState("Kontrak Aktif")
    const [TipeKontrak,setTipeKontrak]= useState("All")
    useEffect(() => {
        const fetchData = async () => {
            await getCategorias();
            await countKontrak();
        }
        fetchData();
    },[sales, address1, extend, TipeKontrak, date, dateEnd])
return(
    <Grid container>
       <Grid xs={6}>
    <Paper sx={{height: '100%', p:3}}>
        Sales:
        <Select  fullWidth value={sales} onChange={event => setSales(event.target.value)}><MenuItem value="-">Semua</MenuItem><MenuItem value="Adnan">Adnan</MenuItem><MenuItem value="Felly">Felly</MenuItem><MenuItem value="Diva">Diva</MenuItem></Select>
        Lokasi:
        <Grid sx={12}></Grid>

        <Select value={address1} whiteSpace="normal" onChange={event => handleChangeAddress(event)}><MenuItem value="-">Semua</MenuItem>{categorias.map((categoria) =><MenuItem multiline value={categoria}>{categoria}</MenuItem>)}</Select>
        <Grid sx={12}></Grid>
        Tipe:
        <Select  fullWidth value={TipeKontrak} onChange={event => setTipeKontrak(event.target.value)}><MenuItem value="All">Semua</MenuItem><MenuItem value="Virtual Office">Virtual Office</MenuItem><MenuItem value="Private Office">Private Office</MenuItem><MenuItem value="Call Center">Call Center</MenuItem></Select>
        <Grid container sx={{mt:5}}>
        <Grid xs={12} lg={6} >
        Dari: 
        <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={date}
                                    onChange={(value)=>setDate(value)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                    </LocalizationProvider>
                    </Grid>
                    <Grid  xs={12} lg={6}>
        Sampai:
        <Button onClick={()=>cekList()} >Ini tombol cek klien sekarang</Button>

        <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={dateEnd}
                                    onChange={(value)=>setDateEnd(value)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                    </LocalizationProvider>
                    </Grid>
                    </Grid>
                    
                    </Paper>
                    </Grid>
                    <Grid xs={1}></Grid>
                    <Grid xs={5}>
    <Paper sx={{height: '100%', p:3}}>
    <Typography variant="h3"><b>Persentase Extend</b></Typography>
    <Typography variant="h1">{hitunganKontrak}%</Typography>
        </Paper>
        </Grid>


    </Grid>
)
}